import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsUUID,
} from 'class-validator';

export class StartVacationScheduleDto {
  @IsUUID()
  @IsNotEmpty()
  scheduleId: string;

  @IsArray()
  @Type(() => String)
  @IsNotEmpty()
  excludeEmployeeOptions: string[];

  @IsDateString()
  @IsOptional({ groups: ['form'] })
  excludeMaternityLeaveUntilDate?: string;

  @IsBoolean()
  @IsOptional({ groups: ['form'] })
  excludeMaternityLeaveUntil?: boolean;

  @IsDateString()
  @IsOptional({ groups: ['form'] })
  excludeUnpayedVacationUntilDate?: string;

  @IsBoolean()
  @IsOptional({ groups: ['form'] })
  excludeUnpayedVacationUntil?: boolean;

  @IsDateString()
  @IsOptional({ groups: ['form'] })
  excludeDisabledContractUntilDate?: string;

  @IsBoolean()
  @IsOptional({ groups: ['form'] })
  excludeDisabledContractUntil?: boolean;

  @IsDateString()
  @IsOptional({ groups: ['form'] })
  includeEmployeeHiredBeforeDate?: string;

  @IsBoolean()
  @IsOptional({ groups: ['form'] })
  includeEmployeeHiredBefore?: boolean;
}
